const ordersStyle = theme => ({
    dateTime: {
        margin:"0 1em"
    },
    select: {
        width: "100%",
    },
    selectWrapper: {
        margin: "0 1em",
        height: "58px",
        width: "100%",
        maxWidth: "192px",
    },
    autocompleteWrapper: {

    },
    headerButton: {
        margin: "1.12em 0",
    },
    keyHashSpan: {
        fontFamily: "Roboto Mono, Helvetica Monospaced, monospace"
    },
    keySearchInput: {
        margin: 0,
    }
});

export default ordersStyle


// WEBPACK FOOTER //
// ./src/assets/jss/material-dashboard-react/views/ordersStyle.jsx